"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_util_1 = require("@giphy/js-util");
const css_1 = require("@emotion/css");
const preact_1 = require("preact");
const hooks_1 = require("preact/hooks");
const play_pause_1 = require("./controls/play-pause");
const volume_1 = require("./controls/volume");
const progress_bar_1 = __importDefault(require("./progress-bar"));
const video_1 = __importDefault(require("./video"));
const containerCss = (0, css_1.css) `
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
`;
const volumeCss = (0, css_1.css) `
    display: flex;
    justify-content: center;
    align-items: center;
`;
const controlsCss = (0, css_1.css) `
    position: absolute;
    bottom: 10px;
    right: 10px;
    left: 10px;
    display: flex;
    justify-content: space-between;
    transition: opacity ease-out 250ms;
`;
const VideoPlayer = (props) => {
    const { width, hideMute, hidePlayPause, hideProgressBar, className, persistentControls } = props;
    const [isHovered, setIsHovered] = (0, hooks_1.useState)(false);
    const [playState, setPlayState] = (0, hooks_1.useState)('paused');
    const [videoEl, _setVideoEl] = (0, hooks_1.useState)(null);
    const [muted, setMuted] = (0, hooks_1.useState)(props.muted);
    const [mutedByBrowser, setMutedByBrowser] = (0, hooks_1.useState)(false);
    const { onStateChange, setVideoEl, onMuted, onUserMuted } = props;
    const height = props.height || (0, js_util_1.getGifHeight)(props.gif, width);
    const combinedSetPlayState = (0, hooks_1.useCallback)((args) => {
        onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange(args);
        setPlayState(args);
    }, [onStateChange, setPlayState]);
    const combinedOnMuted = (0, hooks_1.useCallback)((args) => {
        onMuted === null || onMuted === void 0 ? void 0 : onMuted(args);
        setMutedByBrowser(args);
    }, [setMutedByBrowser, onMuted]);
    const combinedSetVideoEl = (0, hooks_1.useCallback)((args) => {
        setVideoEl === null || setVideoEl === void 0 ? void 0 : setVideoEl(args);
        _setVideoEl(args);
    }, [setVideoEl, _setVideoEl]);
    const toggleMute = () => {
        if (mutedByBrowser) {
            setMutedByBrowser(false);
            setMuted(false);
        }
        else {
            setMuted(!muted);
        }
    };
    (0, hooks_1.useEffect)(() => {
        setMuted(props.muted);
    }, [props.muted]);
    return ((0, preact_1.h)("div", { className: (0, css_1.cx)(containerCss, className), style: { width, height }, onMouseOver: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) },
        (0, preact_1.h)(video_1.default, Object.assign({}, props, { onStateChange: combinedSetPlayState, onMuted: combinedOnMuted, setVideoEl: combinedSetVideoEl, muted: muted })),
        (0, preact_1.h)("div", { style: { opacity: persistentControls || isHovered ? 1 : 0 }, className: controlsCss },
            videoEl && !hidePlayPause ? ((0, preact_1.h)("div", { onClick: () => {
                    if (playState === 'playing')
                        videoEl.pause();
                    else
                        videoEl.play();
                } }, playState === 'playing' ? (0, preact_1.h)(play_pause_1.PauseIcon, null) : (0, preact_1.h)(play_pause_1.PlayIcon, null))) : ((0, preact_1.h)("div", null)),
            !hideMute && ((0, preact_1.h)("div", { className: volumeCss, onClick: (e) => {
                    onUserMuted === null || onUserMuted === void 0 ? void 0 : onUserMuted(!muted);
                    e.preventDefault();
                    toggleMute();
                } }, muted || mutedByBrowser ? (0, preact_1.h)(volume_1.VolumeOffIcon, null) : (0, preact_1.h)(volume_1.VolumeOnIcon, null)))),
        (persistentControls || isHovered) && !hideProgressBar && videoEl ? ((0, preact_1.h)(progress_bar_1.default, { videoEl: videoEl })) : null));
};
const VideoWrapper = (props) => props.controls ? (0, preact_1.h)(VideoPlayer, Object.assign({}, props)) : (0, preact_1.h)(video_1.default, Object.assign({}, props));
VideoWrapper.className = video_1.default.className;
exports.default = VideoWrapper;
//# sourceMappingURL=index.js.map